import React, { createContext, useContext, useCallback, useRef, useState } from "react";
import { usePlatformAuth } from "@/contexts/PlatformAuthContext";

const Ctx = createContext(null);

/**
 * Coordinates the single "Subscribe to unlock the full catalog" conversion nudge
 * across all content types (track, video, image). triggerNudge() is called by each
 * content surface after a guest finishes / views public, unlocked content. It shows
 * AT MOST ONCE per browser session and NEVER for active subscribers; the per-content
 * eligibility (public + unlocked + completion) is decided by each caller.
 */
export function ConversionNudgeProvider({ children }) {
  const { isSubscriber } = usePlatformAuth();
  const [showConvertNudge, setShowConvertNudge] = useState(false);
  const shownRef = useRef(false);

  const triggerNudge = useCallback(() => {
    if (shownRef.current || isSubscriber) return;
    shownRef.current = true;
    setShowConvertNudge(true);
  }, [isSubscriber]);

  const dismissConvertNudge = useCallback(() => setShowConvertNudge(false), []);

  return (
    <Ctx.Provider value={{ showConvertNudge, triggerNudge, dismissConvertNudge }}>
      {children}
    </Ctx.Provider>
  );
}

export const useConversionNudge = () =>
  useContext(Ctx) || { showConvertNudge: false, triggerNudge: () => {}, dismissConvertNudge: () => {} };
